// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 提交回访问卷 POST /strategy-apply/feedback/submit */
export async function strategyApplyFeedbackSubmitUsingPOST(
  body: API.StrategyApplyFeedBackReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/strategy-apply/feedback/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 策略增值申请详情 GET /strategy-apply/info */
export async function strategyApplyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyApplyInfoResp>('/strategy-apply/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略增值包申请列表 GET /strategy-apply/list */
export async function strategyApplyListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListStrategyApplyInfoResp>('/strategy-apply/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 策略增值包签字 POST /strategy-apply/sign */
export async function strategyApplySignUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplySignUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/strategy-apply/sign', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略增值包获取脱敏合同预览件地址 GET /strategy-apply/sign/oss-url */
export async function strategyApplySignOssUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplySignOssUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/strategy-apply/sign/oss-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 查询订单签字状态 POST /strategy-apply/sign/status */
export async function strategyApplySignStatusUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplySignStatusUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/strategy-apply/sign/status', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略增值包获取签字url POST /strategy-apply/sign/url */
export async function strategyApplySignUrlUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplySignUrlUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/strategy-apply/sign/url', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略增值包获取签字url（智能验证码版） POST /strategy-apply/sign/url/v2 */
export async function strategyApplySignUrlV2UsingPOST(
  body: API.StrategyApplyContractV2Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/strategy-apply/sign/url/v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 策略切换增值包校验 GET /strategy-apply/transfer-check */
export async function strategyApplyTransferCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyApplyTransferCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/strategy-apply/transfer-check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略切换增值包申请列表 GET /strategy-apply/transfer-list */
export async function strategyApplyTransferListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListStrategyApplyInfoResp>('/strategy-apply/transfer-list', {
    method: 'GET',
    ...(options || {}),
  });
}
